import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { authGuard } from './guards/auth.guard';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { EmployeesComponent } from './pages/employees/employees.component';
import { CardsComponent } from './pages/cards/cards.component';
import { UnregisteredComponent } from './pages/unregistered/unregistered.component';
import { ViewCardComponent } from './pages/viewpage/view-card.component';
import { EditCardComponent } from './pages/edit-card/edit-card.component';
import { DownloadComponent } from './pages/download/download.component';
import { AiChatComponent } from './pages/ai-chat/ai-chat.component';
import { AnalyticsComponent } from './pages/analytics/analytics.component';
import { ListingFormComponent } from './pages/listing-form/listing-form.component';
import { ListingComponent } from './pages/listing/listing.component';
import { LicenseUpgradeComponent } from './pages/license-upgrade/license-upgrade.component';
import { HelpComponent } from './pages/help/help.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { BookmarkPage } from './pages/bookmark/bookmark.page';
import { AppSettingPage } from './pages/app-setting/app-setting.page';


export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'unregistered', component: UnregisteredComponent },
  { path: '', component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent, data: { breadcrumb: 'Dashboard' } },
      { path: 'employees', component: EmployeesComponent, data: { breadcrumb: 'Employees' } },
      { path: 'cards', component: CardsComponent, data: { breadcrumb: 'My Cards' } },
      { path: 'view/:id', component: ViewCardComponent, data: { breadcrumb: 'View Card' } },
      { path: 'card/:id/edit', component: EditCardComponent, data: { breadcrumb: 'Edit Card' } },
      { path: 'card/:id/download', component: DownloadComponent, data: { breadcrumb: 'Download' } },
      { path: 'ai-chat', component: AiChatComponent, data: { breadcrumb: 'AI Content Generator' } },
      { path: 'analytics', component: AnalyticsComponent, data: { breadcrumb: 'Analytics' } },
      { path: '', redirectTo: '/listing', pathMatch: 'full' },
      { path: 'listing', component: ListingComponent, data: { breadcrumb: 'Listings' } },
      { path: 'listing-form', component: ListingFormComponent, data: { breadcrumb: 'ListingForm' } },
      { path: 'upgrade-license', component: LicenseUpgradeComponent, data: { breadcrumb: 'Upgrade License' } },
      
      // Optional: Route for editing specific listings
      { path: 'listing/:id/edit', component: ListingFormComponent, data: { breadcrumb: 'Edit Listing' } },
      { path: 'help', component: HelpComponent, data: { breadcrumb: 'Help' } },
      { path: 'profile', component: ProfileComponent, data: { breadcrumb: 'Profile' } },
      { path: 'bookmarks', component: BookmarkPage, data: { breadcrumb: 'Bookmarks' } },
      { path: 'app-settings', component: AppSettingPage, data: { breadcrumb: 'App Settings' } }
    ],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', redirectTo: '/login' },
];